angular.module('impactx.search').controller('CatalogItemCtrl', [
    '$redirect',
    'AppConfiguration',
    'panelService',
    '$routeParams',
    'SearchFilterStorage',
    CatalogItemCtrl
]);

function CatalogItemCtrl($redirect, AppConfiguration, panelService, $routeParams, SearchFilterStorage) {
    var self = this;

    self.redirectToDetails = function () {
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.vcatalogId = {value: self.catalog.id};
            filter.dialogFilter = "vcat";
            filter.prgId = {value: 0};
            SearchFilterStorage.setVCatFilter(self.catalog.id, filter);
        }
        $redirect.redirectTo(null, "vcatalog/" + self.catalog.id + (($routeParams.useSetFilter || $routeParams.useSetFilterList) ? "/0/true" : ""));
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    self.getCatalogPanelColor = panelService.getCatalogPanelColor;
}